import {Link} from "react-router-dom";
import {User} from "../../services/UsersService";

interface UsersListItemProps {
  readonly user: User;
  readonly disabled: boolean;
}

const UsersListItem = (props: UsersListItemProps) => {
  return (
    <div className="list-group-item">
      <div className="row align-items-center">
        <div className="col-auto">
          <img src={props.user.circleSrc} width="24px" height="24px" alt="user color circle" className="rounded-circle"></img>
        </div>
        <div className="col ms-n2">
          <h4 className="mb-1">admin: {props.user.adminEmail}</h4>
          <h4 className="small mb-0">id: {props.user.id}</h4>
          {props.user.apiToken && <h4 className="small mb-0">token: {props.user.apiToken}</h4>}
          <h4 className="small mb-0">num cached: {props.user.numCached}</h4>
        </div>
        <div className="col-auto">
          <Link className={`btn btn-sm btn-white ${props.disabled ? "disabled" : ""}`} to={props.user.id.toString()}>
            details
          </Link>
        </div>
      </div>
    </div>
  );
};

export default UsersListItem;
